import React from "react";
import "./FeatureCardOverlay.scss";

interface FeatureCardOverlayProps {
  name: string;
  tagline?: string;
  tags?: readonly string[];
}

/**
 * Live HTML/CSS text layer rendered ON TOP of a project's raw feature art —
 * the on-page counterpart to the baked social/OG card. Because it's real DOM
 * (not pixels), the text is localized, selectable, and crisp at any size.
 * Sizes use container query units (cqw) so it scales with the frame width,
 * matching the 1200×630 baked-card proportions in both the carousel and the
 * full-width case-study hero. Place inside a position:relative,
 * container-type:inline-size frame.
 */
const FeatureCardOverlay: React.FC<FeatureCardOverlayProps> = ({ name, tagline, tags }) => (
  <div className="fc-overlay" aria-hidden="true">
    <div className="fc-scrim" />
    <div className="fc-content">
      <span className="fc-wordmark">devbloom</span>
      <div className="fc-stack">
        <span className="fc-name">{name}</span>
        {tagline && <span className="fc-tagline">{tagline}</span>}
        {tags && tags.length > 0 && (
          <span className="fc-tags">
            {tags.slice(0, 4).map((t) => (
              <span className="fc-tag" key={t}>{t}</span>
            ))}
          </span>
        )}
      </div>
    </div>
  </div>
);

export default FeatureCardOverlay;
